import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';

import FormPersona from '../../tramites/formularios/FormPersona';
import FormAutorizacionOtros from '../../tramites/formularios/FormAutorizacionOtros';
import getAutorizacionPorId from '../../../graphql/querys/tramites/getAutorizacionOtraPorId.graphql';
import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import updateAutorizacionOtraPorId from '../../../graphql/mutations/tramites/updateAutorizacionOtraPorId.graphql';
import getAutorizacionesOtras from '../../../graphql/querys/tramites/getAutorizacionesOtras.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(updateAutorizacionOtraPorId, {
    name: 'updateAutorizacion',
    options: {
      refetchQueries: [{ query: getAutorizacionesOtras }],
    },
  }),
  graphql(getUsuario)
)
class EditarAutorizacionOtra extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      autorizante: {},
      certificacion: {},
      ente_receptor: '',
      texto_autorizacion: '',
      fecha_creacion: '',
      step: 0,
      guardado: false,
      loading: true,
    };

    this.props.client
      .query({
        query: getAutorizacionPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const autorizacion = res.data.getAutorizacionPorId;

        this.setState({
          loading: false,
          autorizante: autorizacion.autorizante,
          ente_receptor: autorizacion.ente_receptor,
          texto_autorizacion: autorizacion.texto_autorizacion,
          fecha_creacion: autorizacion.fecha_creacion,
          _id: autorizacion._id,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarPersona = this.guardarPersona.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.guardarDatosAutorizacion = this.guardarDatosAutorizacion.bind(this);
  }

  guardarPersona(persona) {
    // console.log(persona);
    this.setState(
      {
        declarante: {
          ...this.state.declarante,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  }

  guardarDatosAutorizacion(datos) {
    //Actualizamos la persona si es que existe, o la insertamos si creo una nueva.
    //Todo esto gracias al upsert en mongoDB.

    //Armamos una copia del objeto persona, y le sacmaos la propiedad __typename para que sea del tipo "InputPersona" de graphql
    let copiaPersona = this.state.declarante;
    delete copiaPersona.__typename;

    this.props
      .createPers({
        variables: { persona: copiaPersona },
      })
      .then(res => {
        let persona = res.data.insertPersona;

        let nuevaAutorizacion = {
          texto_autorizacion: datos.autorizacion,
          fecha_creacion: this.state.fecha_creacion,
          idAutorizante: persona._id,
          ente_receptor: datos.ente_receptor,
          idOrganismo: this.props.data.getUsuario.organismo._id,
        };

        this.props
          .updateAutorizacion({
            variables: {
              _id: this.state._id,
              nuevaAutorizacion: nuevaAutorizacion,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(resAutorizacion => {
            notification.success({
              message: 'Actualizacion Correcta',
              description:
                'Se ha registrado los nuevos datos de la autorizacion',
            });

            this.props.history.push('/admin/autorizaciones_otras');
          })
          .catch(err => {
            console.log('Error en la actualizacion de la autorizacion 2');
            console.log(err);
            errorService(err, {
              _id: this.state._id,
              nuevaAutorizacion: nuevaAutorizacion,
            });
            Modal.error({
              title: 'Error en la actualizacion de la autorizacion',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      })
      .catch(err => {
        console.log('Error en la actualizacion de la autorizacion 1');
        console.log(err);
        errorService(err, {
          persona: copiaPersona,
        });
        Modal.error({
          title: 'Error en la actualizacion de la autorizacion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  siguientePaso() {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  }

  anteriorPaso() {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { Step } = Steps;
    let { step } = this.state;
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Certificacion</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Certificacion
          </h2>
          <br />
          <Steps className="stepsFormularios" current={step}>
            <Step title="Datos Persona" />
            <Step title="Datos de la Autorizacion" />
            {/* <Step title="Seleccionar el Modelo Nota" />
            <Step title="Datos de la Certificacion" />
            <Step title="Generacion de Nota" />
            <Step title="Editar e Imprimir" /> */}
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <FormPersona
                className="formularios"
                onSubmit={this.guardarPersona}
                onAnterior={() => this.props.history.goBack()}
                persona={this.state.autorizante}
              />
            )}
            {step === 1 && (
              <FormAutorizacionOtros
                onSubmit={this.guardarDatosAutorizacion}
                datos={{
                  autorizacion: this.state.texto_autorizacion,
                  ente_receptor: this.state.ente_receptor,
                }}
                config={{ creacion: false }}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarAutorizacionOtra);
